import styled from "styled-components";
export const Radiobox = styled.input `
  transform: scale(${props => props.$scale || 1.5});
  margin-left: 10px;
  position: relative;
`;
